<div class="dx-card" id="accordion">
  <dx-accordion
    #accordion
    [dataSource]="[{ title: 'Component Specification', item: {} }]"
    [collapsible]="true"
    [animationDuration]="300"
    [focusStateEnabled]="false"
    [hoverStateEnabled]="false"
    [selectedIndex]="-1"
    (onSelectionChanged)="onAccordionClick($event)"
  >
    <div *dxTemplate="let itemData of 'title'">
      <h3>
        <span style="padding-left: 0.3em">Component Specification</span>
      </h3>
    </div>
    <div *dxTemplate="let itemData of 'item'">
      <div class="component-cards-container">
        <!-- Kachel 1: Jacket/Cover (abhängig von Hard-/Softcover) -->
        <div class="component-card">
          <div class="card-header">
            <h4>{{ isHardcover() ? "Jacket" : "Cover" }}</h4>
          </div>
          <div class="card-content">
            <dx-form #jacketForm labelMode="floating">
              <dxi-item itemType="group" [colCount]="1">
                <!-- Paper -->
                <dxi-item name="jacketPaper">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="jacketPaperFieldItems"
                      label="Paper"
                      displayExpr="displayValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [(value)]="selectedJacketPaper"
                    ></dx-select-box>
                  </div>
                </dxi-item>

                <!-- Front Color -->
                <dxi-item name="frontColor">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="frontColorFieldItems"
                      label="Front Color"
                      displayExpr="displayValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [(value)]="selectedFrontColor"
                    ></dx-select-box>
                  </div>
                </dxi-item>

                <!-- Back Color -->
                <dxi-item name="backColor">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="backColorFieldItems"
                      label="Back Color"
                      displayExpr="displayValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [(value)]="selectedBackColor"
                    ></dx-select-box>
                  </div>
                </dxi-item>

                <!-- Finishing -->
                <dxi-item name="finishing">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="finishingFieldItems"
                      label="Finishing"
                      displayExpr="displayValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [(value)]="selectedFinishing"
                    ></dx-select-box>
                  </div>
                </dxi-item>

                <!-- Special Effects -->
                <dxi-item name="specialEffects">
                  <div *dxTemplate="let data">
                    <dx-drop-down-box
                      [(value)]="selectedSpecialEffects"
                      [dataSource]="specialEffectsFieldItems"
                      displayExpr="displayValue"
                      label="Special Effects"
                      stylingMode="underlined"
                      fieldTemplate="field"
                      labelMode="static"
                    >
                      <div *dxTemplate="let data of 'field'">
                        <dx-text-box [value]="specialEffectsText"></dx-text-box>
                      </div>
                      <dx-list
                        [dataSource]="specialEffectsFieldItems"
                        selectionMode="multiple"
                        displayExpr="displayValue"
                        [(selectedItems)]="selectedSpecialEffects"
                      ></dx-list>
                    </dx-drop-down-box>
                  </div>
                </dxi-item>
              </dxi-item>
            </dx-form>
          </div>
        </div>

        <!-- Kachel 2: Endsheets -->
        <div class="component-card" [class.disabled]="!endsheetEnabled">
          <div class="card-header">
            <div class="card-header-content">
              <h4>Endsheet</h4>
              <button
                type="button"
                class="toggle-button"
                [class.active]="endsheetEnabled"
                (click)="toggleEndsheet()"
                [title]="
                  endsheetEnabled ? 'Disable Endsheet' : 'Enable Endsheet'
                "
              >
                <i
                  [class]="endsheetEnabled ? 'dx-icon-check' : 'dx-icon-plus'"
                ></i>
              </button>
            </div>
          </div>
          <div class="card-content">
            <dx-form #endsheetForm labelMode="floating">
              <dxi-item itemType="group" [colCount]="1">
                <!-- Endsheet Paper -->
                <dxi-item name="endsheetPaper">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="endsheetPaperFieldItems"
                      label="Paper"
                      displayExpr="displayValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [(value)]="selectedEndsheetPaper"
                      [disabled]="!endsheetEnabled"
                    ></dx-select-box>
                  </div>
                </dxi-item>

                <!-- Endsheet Front Color -->
                <dxi-item name="endsheetFrontColor">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="endsheetFrontColorFieldItems"
                      label="Front Color"
                      displayExpr="displayValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [(value)]="selectedEndsheetFrontColor"
                      [disabled]="!endsheetEnabled"
                    ></dx-select-box>
                  </div>
                </dxi-item>

                <!-- Endsheet Back Color -->
                <dxi-item name="endsheetBackColor">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="endsheetBackColorFieldItems"
                      label="Back Color"
                      displayExpr="displayValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [(value)]="selectedEndsheetBackColor"
                      [disabled]="!endsheetEnabled"
                    ></dx-select-box>
                  </div>
                </dxi-item>
              </dxi-item>
            </dx-form>
          </div>
        </div>

        <!-- Kachel 3: Insert-Kacheln (dynamisch) -->
        <!-- Bestehende Insert-Kacheln -->
        <div
          *ngFor="let insert of inserts; let i = index"
          class="component-card"
        >
          <div class="card-header">
            <div class="card-header-content">
              <h4>Insert</h4>
              <button
                type="button"
                class="remove-button"
                (click)="removeInsert(insert.id)"
                title="Remove Insert"
              >
                <i class="dx-icon-remove"></i>
              </button>
            </div>
          </div>
          <div class="card-content">
            <dx-form labelMode="floating">
              <dxi-item itemType="group" [colCount]="1">
                <!-- Insert Pages -->
                <dxi-item name="insertPages">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="insertPagesFieldItems"
                      label="Pages"
                      displayExpr="displayValue"
                      valueExpr="keyValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [value]="insert.selectedPages?.keyValue"
                      (onValueChanged)="insertPagesChanged($event, insert.id)"
                    ></dx-select-box>
                  </div>
                </dxi-item>

                <!-- Insert Paper -->
                <dxi-item name="insertPaper">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="insertPaperFieldItems"
                      label="Paper"
                      displayExpr="displayValue"
                      valueExpr="keyValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [value]="insert.selectedPaper?.keyValue"
                      (onValueChanged)="insertPaperChanged($event, insert.id)"
                    ></dx-select-box>
                  </div>
                </dxi-item>

                <!-- Insert Colors -->
                <dxi-item name="insertColors">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="insertColorsFieldItems"
                      label="Colors"
                      displayExpr="displayValue"
                      valueExpr="keyValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [value]="insert.selectedColors?.keyValue"
                      (onValueChanged)="insertColorsChanged($event, insert.id)"
                    ></dx-select-box>
                  </div>
                </dxi-item>

                <!-- Insert Special Ink -->
                <dxi-item name="insertSpecialInk">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="insertSpecialInkFieldItems"
                      label="Special Ink"
                      displayExpr="displayValue"
                      valueExpr="keyValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [value]="insert.selectedSpecialInk?.keyValue"
                      (onValueChanged)="
                        insertSpecialInkChanged($event, insert.id)
                      "
                    >
                    </dx-select-box>
                  </div>
                </dxi-item>
              </dxi-item>
            </dx-form>
          </div>
        </div>

        <div *ngFor="let tipIn of tipIns; let i = index" class="component-card">
          <div class="card-header">
            <div class="card-header-content">
              <h4>Tip In</h4>
              <button
                type="button"
                class="remove-button"
                (click)="removeTipIn(tipIn.id)"
                title="Remove Tip-In"
              >
                <i class="dx-icon-remove"></i>
              </button>
            </div>
          </div>
          <div class="card-content">
            <dx-form labelMode="floating">
              <dxi-item itemType="group" [colCount]="1">
                <!-- Tip-In Pages -->
                <dxi-item name="tipInPages">
                  <div *dxTemplate="let data">
                    <dx-text-box
                      stylingMode="underlined"
                      label="Pages"
                      [readOnly]="true"
                      [hoverStateEnabled]="false"
                      style="caret-color: transparent"
                      [value]="tipIn.selectedPages"
                    ></dx-text-box>
                  </div>
                </dxi-item>
                <!-- Tip-In Paper -->
                <dxi-item name="tipInPaper">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="tipInPaperFieldItems"
                      label="Paper"
                      displayExpr="displayValue"
                      valueExpr="keyValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [value]="tipIn.selectedPaper?.keyValue"
                      (onValueChanged)="tipInPaperChanged($event, tipIn.id)"
                    ></dx-select-box>
                  </div>
                </dxi-item>

                <!-- Tip-In Colors -->
                <dxi-item name="tipInColors">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="tipInColorsFieldItems"
                      label="Colors"
                      displayExpr="displayValue"
                      valueExpr="keyValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [value]="tipIn.selectedColors?.keyValue"
                      (onValueChanged)="tipInColorsChanged($event, tipIn.id)"
                    ></dx-select-box>
                  </div>
                </dxi-item>

                <!-- Tip-In Special Ink -->
                <dxi-item name="tipInSpecialInk">
                  <div *dxTemplate="let data">
                    <dx-select-box
                      stylingMode="underlined"
                      [dataSource]="tipInSpecialInkFieldItems"
                      label="Special Ink"
                      displayExpr="displayValue"
                      valueExpr="keyValue"
                      [searchEnabled]="false"
                      style="caret-color: transparent"
                      [value]="tipIn.selectedSpecialInk?.keyValue"
                      (onValueChanged)="
                        tipInSpecialInkChanged($event, tipIn.id)
                      "
                    >
                      <div *dxTemplate="let data of 'field'">
                        <dx-text-box
                          [value]="
                            tipIn.selectedSpecialInk?.displayValue || 'None'
                          "
                        ></dx-text-box>
                      </div>
                    </dx-select-box>
                  </div>
                </dxi-item>
              </dxi-item>
            </dx-form>
          </div>
        </div>

        <div class="insert-component-card">
          <!-- Leere Insert/Tip in-Kachel (Plus-Button) -->
          <div class="component-card empty-insert-card">
            <div class="card-content empty-insert-content">
              <div class="empty-insert-wrapper">
                <h4>Insert</h4>
                <button
                  type="button"
                  class="add-insert-button"
                  (click)="addInsert()"
                  title="Add Insert"
                >
                  <i class="dx-icon-plus"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="component-card empty-insert-card">
            <div class="card-content empty-insert-content">
              <div class="empty-insert-wrapper">
                <h4>Tip-In</h4>
                <button
                  type="button"
                  class="add-insert-button"
                  (click)="addTipIn()"
                  title="Add Tip-In"
                >
                  <i class="dx-icon-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dx-accordion>
</div>
